document.addEventListener('DOMContentLoaded', function () {

  /* Mobile menu toggle */
  var menuBtn = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      var isOpen = mobileNav.classList.contains('is-open');
      menuBtn.querySelector('[data-icon-open]').classList.toggle('hidden', isOpen);
      menuBtn.querySelector('[data-icon-close]').classList.toggle('hidden', !isOpen);
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        menuBtn.querySelector('[data-icon-open]').classList.remove('hidden');
        menuBtn.querySelector('[data-icon-close]').classList.add('hidden');
      });
    });
  }

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.fullSrc || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* Quantity selectors (product page + cart) */
  document.querySelectorAll('[data-qty-selector]').forEach(function (sel) {
    var input = sel.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    sel.querySelector('[data-qty-minus]').addEventListener('click', function () {
      var val = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    sel.querySelector('[data-qty-plus]').addEventListener('click', function () {
      var val = Math.min(max, (parseInt(input.value, 10) || min) + 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Cart line quantity change -> update via Ajax API, then reload to reflect totals */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.line;
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Cart line remove */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.line;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Clear cart */
  var clearBtn = document.querySelector('[data-cart-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      fetch('/cart/clear.js', { method: 'POST' }).then(function () { window.location.reload(); });
    });
  }

  /* Add to cart - button label feedback */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-add-to-cart-btn]');
      if (btn) {
        window.setTimeout(function () {
          var original = btn.dataset.originalText || btn.textContent;
          btn.dataset.originalText = original;
          btn.textContent = btn.dataset.addedText || 'Added to Cart \u2713';
          setTimeout(function () { btn.textContent = original; }, 2000);
        }, 300);
      }
    });
  });

});
